import React, { useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Portfolio from "./components/Portfolio";
import Gallery from "./components/Gallery";
import Certifications from "./components/Certifications";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import WhatsAppFloat from "./components/WhatsAppFloat";
import SEOHead from "./components/SEOHead";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ProfileManager from "./pages/admin/ProfileManager";
import SkillsManager from "./pages/admin/SkillsManager";
import PortfolioManager from "./pages/admin/PortfolioManager";
import CertificationsManager from "./pages/admin/CertificationsManager";
import MessagesAndSite from "./pages/admin/MessagesAndSite";
import TestimonialsManager from "./pages/admin/TestimonialsManager";
import PostsManager from "./pages/admin/PostsManager";
import ServicesManager from "./pages/admin/ServicesManager";
import GalleryManager from "./pages/admin/GalleryManager";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

function CustomCursor() {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);
  useEffect(() => {
    const move = (e) => {
      if (cursorRef.current) { cursorRef.current.style.left = e.clientX + 'px'; cursorRef.current.style.top = e.clientY + 'px'; }
      if (ringRef.current) { ringRef.current.style.left = e.clientX + 'px'; ringRef.current.style.top = e.clientY + 'px'; }
    };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, []);
  return (<><div className="cursor" ref={cursorRef} /><div className="cursor-ring" ref={ringRef} /></>);
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", gap: 12, color: "#6a6a88", fontFamily: "'DM Sans', sans-serif" }}>
      <Loader2 size={22} style={{ animation: "spin 1s linear infinite" }} />Memuat...
    </div>
  );
  if (!user) return <Navigate to="/admin" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

function PublicSite() {
  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", cursor: "none" }}>
      <SEOHead />
      <CustomCursor />
      <Navbar />
      <main>
        <section id="home"><Hero /></section>
        <section id="services"><Services /></section>
        <section id="about"><About /></section>
        <section id="skills"><Skills /></section>
        <section id="portfolio"><Portfolio /></section>
        <section id="gallery"><Gallery /></section>
        <section id="testimonials"><Testimonials /></section>
        <section id="certifications"><Certifications /></section>
        <section id="contact"><Contact /></section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/profile" element={<ProtectedRoute><ProfileManager /></ProtectedRoute>} />
          <Route path="/admin/skills" element={<ProtectedRoute><SkillsManager /></ProtectedRoute>} />
          <Route path="/admin/portfolio" element={<ProtectedRoute><PortfolioManager /></ProtectedRoute>} />
          <Route path="/admin/certifications" element={<ProtectedRoute><CertificationsManager /></ProtectedRoute>} />
          <Route path="/admin/testimonials" element={<ProtectedRoute><TestimonialsManager /></ProtectedRoute>} />
          <Route path="/admin/blog" element={<ProtectedRoute><PostsManager /></ProtectedRoute>} />
          <Route path="/admin/services" element={<ProtectedRoute><ServicesManager /></ProtectedRoute>} />
          <Route path="/admin/gallery" element={<ProtectedRoute><GalleryManager /></ProtectedRoute>} />
          <Route path="/admin/messages" element={<ProtectedRoute><MessagesAndSite /></ProtectedRoute>} />
          <Route path="/admin/site" element={<ProtectedRoute><MessagesAndSite /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}
export default App;
